export var NavigationDropdownMode;
(function (NavigationDropdownMode) {
    NavigationDropdownMode[NavigationDropdownMode["None"] = 0] = "None";
    NavigationDropdownMode[NavigationDropdownMode["TwoLevels"] = 1] = "TwoLevels";
    NavigationDropdownMode[NavigationDropdownMode["TwoLevelsCard"] = 2] = "TwoLevelsCard";
    NavigationDropdownMode[NavigationDropdownMode["FourLevels"] = 3] = "FourLevels";
})(NavigationDropdownMode || (NavigationDropdownMode = {}));
